import {createSlice} from "@reduxjs/toolkit";

const initialrecipesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  recipeForEdit: undefined,
  plans: null,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const recipesSlice = createSlice({
  name: "recipes",
  initialState: initialrecipesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getrecipeById
    recipeFetched: (state, action) => {
      state.actionsLoading = false;
      state.recipeForEdit = action.payload.recipeForEdit;
      state.error = null;
    },
    // findrecipes
    recipesFetched: (state, action) => {
      const { totalCount, entities, plans } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.plans = plans;
      state.totalCount = totalCount;
    },
    // createrecipe
    recipeCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.recipe);
    },
    // updaterecipe
    recipeUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.recipe.id) {
          return entity;
        }
        return entity;
      });
    },
    // deleterecipe
    recipeDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleterecipes
    recipesDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    }
  }
});
